import React from "react";
import CustomButton from "../Buttons/CustomButton";
import Link from "next/link";
import Image from "next/image";
import slider1 from "@/Helper/images/slider/transportation/slider1.png";
const Corporate = () => {
  return (
    <div className="industry_container">
      <div className="industry_left_content">
        <p className="heading">
          Powerful Digital Signage Solution for Corporate Offices
        </p>
        <p className="subheading">
          Leverage multifaceted potential of digital signage that has a vast
          array of applications across diverse educational organizations.
        </p>

        <div className="btn_container">
          <Link href={"/digital-signage-software-for-corporate"}>
            <CustomButton Text={"View More"}></CustomButton>
          </Link>
        </div>
      </div>
      <div className="industry_right_content">
        <div className="slider_bg normal_bg">
          <Image
            src={slider1}
            alt="Powerful Digital Signage Solution for Corporate Offices"
            width={457}
            height={257}
            className="productbanner_imageslider"
            loading="eager"
          />
        </div>
      </div>
    </div>
  );
};

export default Corporate;
